module.exports = __webpack_public_path__ + "static/media/kuaraModal.3c4f704d.svg";